module.exports = __webpack_public_path__ + "img/Man-5.14d74528.svg";